import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbTokenColorPickerComponent } from 'libs/gb-dashboard/shared/ui/src/lib/gb-token-color-picker/gb-token-color-picker.component'
import {
  FONT_FAMILY_OPTIONS,
  FONT_STYLE_OPTIONS,
  FONT_WEIGHT_OPTIONS,
  TEXT_ALIGN_OPTIONS,
} from '../presenter-tools-options'

@Component({
  selector: 'gb-presenter-tools-text',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbTokenColorPickerComponent,
  ],
  templateUrl: './gb-presenter-tools-text.component.html',
  styleUrl: './gb-presenter-tools-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsTextComponent {
  @Input({ required: true }) toolsFormGroup!: FormGroup
  @Input() hideFields: string[] = []

  fontFamilyOptions = FONT_FAMILY_OPTIONS
  fontWeightOptions = FONT_WEIGHT_OPTIONS
  fontStyleOptions = FONT_STYLE_OPTIONS
  textAlignOptions = TEXT_ALIGN_OPTIONS

  get fontFamilyControl(): FormControl {
    return this.toolsFormGroup.get('font_family') as FormControl
  }

  get fontSizeControl(): FormControl {
    return this.toolsFormGroup.get('font_size') as FormControl
  }

  get fontWeightControl(): FormControl {
    return this.toolsFormGroup.get('font_weight') as FormControl
  }

  get fontStyleControl(): FormControl {
    return this.toolsFormGroup.get('font_style') as FormControl
  }

  get textAlignControl(): FormControl {
    return this.toolsFormGroup.get('text_align') as FormControl
  }

  get colorControl(): FormControl {
    return this.toolsFormGroup.get('color') as FormControl
  }

  isFieldVisible(fieldName: string): boolean {
    return !this.hideFields.includes(fieldName)
  }
}
